export default class Functions {

  static createCustomCatCompleteWidget() {

      $.widget('custom.catcomplete', $.ui.autocomplete, {

      options: {
        resetSelectedItem: null,
        afterCreate : null
      },

      _create : function() {

        var parentMethod = $.ui.autocomplete.prototype._create;
        parentMethod.apply(this, arguments);

        if(this.options.afterCreate) {
          var callback = this.options.afterCreate;
          callback.apply(this.element, []);
        }
      },

      makeEditable : function() {
        this.options.disabled = false;
        $(this.element).attr('readonly', false);
        $(this.element).removeClass('input-disabled');
      },

      makeReadOnly : function() {
        this.options.disabled = true;
        $(this.element).attr('readonly', true);
        $(this.element).addClass('input-disabled');
      },

      _change: function( event ) {

        if ( this.previous !== this._value) {
          this._removeIfInvalid();
          var parentMethod = $.ui.autocomplete.prototype._change;
          parentMethod.apply(this, arguments);
        }
      },

      _removeIfInvalid: function() {

        if (this.selectedItem) {
          return;
        }

        // Remove invalid value
        $(this.element).val("");
        $(this.element).trigger('change');
        this.term = "";
        if(this.options.resetSelectedItem) {
          var callback = this.options.resetSelectedItem;
          callback.apply(this.element, []);
        }
      }
    });
  }

  static initPhoneInputs(parent = '') {

    var phone_mask = "+7 ?(999) 999-99-99";
    var phone_inputs = Functions._getElements("input.phone", parent);

    phone_inputs.mask(phone_mask).focusout(function() {

      var is_empty_value = $(this).val() === "+7 (___) ___-__-__";

      if(is_empty_value) {
        $(this).val('');
      }
    });
  }

  static initPopupImages(parent = '') {
    Functions._getElements("a.imagebox", parent).colorbox({'photo': true});
  }

  static initDateTimeInputs(parent = '') {
    Functions._getElements(".date", parent).datepicker();
    Functions._getElements(".time", parent).timepicker();
    Functions._getElements(".datetime", parent).datetimepicker().change(function() {
      $(this.parentNode).find('.error').html('');
    });
  };

  static initClearableInputs() {
    $(document).on('input keypress paste change', '.clearable', function(event){
      $(this)[Functions.getToggleClassMethod(this.value)]('x');
    }).on('mousemove', '.x', function( e ){
      var hover = this.offsetWidth-18 < e.clientX-this.getBoundingClientRect().left;
      $(this)[Functions.getToggleClassMethod(hover)]('onX');
    }).on('touchstart click', '.onX', function( e ){
        e.preventDefault();
        $(this).removeClass('x onX').val('').change();
    });

    $('.clearable').trigger("input");
  };

  static getToggleClassMethod(value){
    return value ? 'addClass' : 'removeClass';
  };

  static initSelectAllButtons(parent = '') {

    var select_all_buttons = Functions._getElements('.select_all_button', parent);

    select_all_buttons.click(function (event) {

      event.preventDefault();

      var dependend_checkboxes_selector = $(this).data('elements');

      $(dependend_checkboxes_selector).attr('checked', true);
    });
  }

  static initUnselectAllButtons(parent = '') {

    var unselect_all_buttons = Functions._getElements('.unselect_all_button', parent);

    unselect_all_buttons.click(function (event) {

      event.preventDefault();

      var dependend_checkboxes_selector = $(this).data('elements');

      $(dependend_checkboxes_selector).attr('checked', false);
    });

  }

  static _getElements(selector, parent = '') {
    return parent === '' ? $(selector) : $(parent).find(selector);
  }
  
  static addButtonLoadingSpinner(button) {
    $(button).after(Functions._getButtonLoadingSpinner());
  }

  static removeButtonLoadingSpinner(button) {
    $(button).next('.button_spinner').remove();
  }

  static _getButtonLoadingSpinner(class_attr = 'button_spinner') {
    return '<img class="' + class_attr + '" src="/common/image/loading.gif" alt="" />'
  }
};



/** WEBPACK FOOTER **
 ** ./src/common/functions.js
 **/